import { FC, useCallback } from 'react';
import { useDispatch } from 'react-redux';

import sizes from 'constants/sizes';
import { useTranslate } from 'hooks/useTranslate';
import { setModal } from 'modules/_shared/redux/modalActions';
import IncentivesMarketTermsModal from 'modules/incentivesMarket/modals/IncentivesMarketTermsModal';
import EditIncentivesMarketTermsAndConditionsTemplateModal from 'modules/incentivesMarket/modals/EditIncentivesMarketTermsAndConditionsTemplate';
import { EditIncentivesMarketTermsAndConditionsTemplateModalProvider } from 'modules/incentivesMarket/modals/EditIncentivesMarketTermsAndConditionsTemplate/context/EditIncentivesMarketTermsAndConditionsTemplateModalContext';

type IncentivesMarketAdminPanelConfigurationOfferConditionsProps = {
  societyId: string;
};

const IncentivesMarketAdminPanelConfigurationOfferConditions: FC<
  IncentivesMarketAdminPanelConfigurationOfferConditionsProps
> = ({ societyId }) => {
  const { t } = useTranslate();
  const dispatch = useDispatch();

  const handleViewConditions = () => {
    dispatch(setModal(<IncentivesMarketTermsModal size={sizes.XL} />));
  };

  const handleEditConditions = useCallback(() => {
    dispatch(
      setModal(
        <EditIncentivesMarketTermsAndConditionsTemplateModalProvider
          societyId={societyId}
        >
          <EditIncentivesMarketTermsAndConditionsTemplateModal />
        </EditIncentivesMarketTermsAndConditionsTemplateModalProvider>
      )
    );
  }, [dispatch, societyId]);

  return (
    <div className="card card-bordered mb-4">
      <div className="card-inner">
        <h6 className="card-title mb-1">
          <em className="icon ni ni-file-docs mr-2 text-primary" />
          {t('IncentivesMarketAdminConfigSection1Title')}
        </h6>
        <p className="text-soft fs-13px mb-4">
          {t('IncentivesMarketAdminConfigSection1Description')}
        </p>

        <div className="doc-item align-items-start align-items-md-center">
          <div className="doc-icon bg-primary-dim text-primary">
            <em className="icon ni ni-file-docs" />
          </div>

          <div className="flex-grow-1">
            <strong className="fs-13px d-block">
              {t('IncentivesMarketAdminConfigOfferConditionsTitle')}
            </strong>
            <div className="text-soft fs-12px">
              {t('IncentivesMarketAdminConfigOfferConditionsSubtitle')}
            </div>
          </div>

          <div className="d-flex align-items-center flex-wrap flex-shrink-0 mt-3 mt-md-0 ml-md-3">
            <button
              type="button"
              className="btn btn-outline-secondary btn-sm mr-2 mb-2 mb-md-0"
              onClick={handleViewConditions}
            >
              {t('IncentivesMarketConditionsViewPage')}
            </button>
            <button
              type="button"
              className="btn btn-primary btn-sm mb-2 mb-md-0"
              onClick={handleEditConditions}
            >
              {t('Edit')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IncentivesMarketAdminPanelConfigurationOfferConditions;
